import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import { Toast, Lazyload } from 'vant'
import 'vant/lib/index.css'
import Vuex from 'vuex'
// import 'waps-ui';
import { router } from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import echarts from 'echarts'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import wx from 'weixin-js-sdk'
import config from './js/config'
import common from './js/common.js'
import capUtils from './js/capUtils'
import article_config from './js/article_config.js'
import union_utils from './js/union_utils.js'

import {
  log,
  initConfig,
  goto,
  formatData,
  login,
  getOrderListByData,
  getOrderListByPid,
  getOrderCountByData,
  getOrderChart,
  getCategory,
  getSelectGoods,
  getSelectJFGoods,
  getSelectGoodsParams,
  getSelectJFGoodsParams,
  getUnionLink,
  getOrderLogListByData,
  getUrlParamValue,
  getUserPayTo,
  getUserPayList,
  getUserSubmit,
  getSubConfig,
  getUserLevel,
  getChangeLink,
  getBase64img,
  getSelectSkuList,
  getCategoryList,
  getEventsApi,
  getPidLevelCountList,
  getPhoneRegist,
  modifyPassword,
  getPhoneVerifyCode,
  checkPhoneVerifyCode,
  getWxQRUrl,
  syncUserOpenid,
  getWxAppQrcode,
  getWxUserinfo,
  getGloabl_WxUserinfo,
  saveUserinfoToServer,
  getUpdatePhone,
  getOrderBySumbit,
  getOrderByFinishXls,
  getXls,
  resetPassword,
  postImage,
  sendMessageToWechat,
  sendMessageToWechat_ByTs,
  submitToExamine,
  checkExamine,
  getQrUrl,
  getFansList,
  getAccountListByPhone,
  auto_login,
  getShareDatas,
  getNewChannelName,
  getIncometByData,
  getLevelCountTotal,
  getEverydayCountList,
  getEverydayUserCountList,
  getLevelCountData,
  sendMessageToPublic,
  getGroupActiveValue,
  getPopDatas,
  getDatasWithUrlAndParams,
  getDatasWithUrlAndParams_Post,
  clickHomeModelTo,
  getActionInfo,
  getActionList,
  getPid,
  getReturnCashData,
  getRobotByChannelname,
  getRobotList,
  postContentToRobot,
  getPostToRobotData,
  getDataListFromRobot,
  getDataListFromRobot_noPush,
  getDataListFromRobot_Pushed,
  getDataListFromRobot_All,
  getAllDataListFromRobot_withLimitTime,
  deleteDataFromRobot,
  sendRobotStatus,
  sendRobotSkuList_Sorted,
  getUserInfo,
  postWxUserData,
  getUserActiveStatus,
  submitToGetAward,
  getUserPayToAll,
  getWxPublicSignature,
  saveShortUrl, getSkuBaseInfo, getSkuBigInfo,
  getGiftQuery, getGiftInfo
} from './js/utils.js'
// eslint-disable-next-line no-unused-vars
import { post, get, postForm, postData, postJson, postJsonForLongTimeout } from './js/http.js'
import md5 from 'js-md5'
import store from './store'
import 'iview/dist/styles/iview.css'

import VueClipboard from 'vue-clipboard2'

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(Vant)
Vue.use(Vuex)
Vue.use(router)
Vue.use(VueAxios, axios)
Vue.use(VueClipboard)
Vue.use(mavonEditor)
Vue.use(VideoPlayer)
Vue.use(Lazyload)

Vue.prototype.$vantToast = Toast
Vue.prototype.$config = config
Vue.prototype.$common = common
Vue.prototype.$capUtils = capUtils
Vue.prototype.$union_utils = union_utils
Vue.prototype.$echarts = echarts
Vue.prototype.$article_config = article_config
Vue.prototype.$wx = wx
Vue.prototype.$md5 = md5
Vue.prototype.$axios = axios
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$postForm = postForm
Vue.prototype.$postData = postData
Vue.prototype.$postJson = postJson
Vue.prototype.$log = log
Vue.prototype.$initConfig = initConfig
Vue.prototype.$goto = goto
Vue.prototype.$formatData = formatData
Vue.prototype.$login = login
Vue.prototype.$getOrderListByData = getOrderListByData
Vue.prototype.$getOrderListByPid = getOrderListByPid
Vue.prototype.$getOrderCountByData = getOrderCountByData
Vue.prototype.$getOrderChart = getOrderChart
Vue.prototype.$getCategory = getCategory
Vue.prototype.$getSelectGoods = getSelectGoods
Vue.prototype.$getSkuBaseInfo = getSkuBaseInfo
Vue.prototype.$getSkuBigInfo = getSkuBigInfo
Vue.prototype.$getGiftQuery = getGiftQuery
Vue.prototype.$getGiftInfo = getGiftInfo
Vue.prototype.$getSelectJFGoods = getSelectJFGoods
Vue.prototype.$getSelectGoodsParams = getSelectGoodsParams
Vue.prototype.$getSelectJFGoodsParams = getSelectJFGoodsParams
Vue.prototype.$getUnionLink = getUnionLink
Vue.prototype.$getOrderLogListByData = getOrderLogListByData
Vue.prototype.$getUrlParamValue = getUrlParamValue
Vue.prototype.$getUserPayTo = getUserPayTo
Vue.prototype.$getUserPayList = getUserPayList
Vue.prototype.$getUserSubmit = getUserSubmit
Vue.prototype.$getSubConfig = getSubConfig
Vue.prototype.$getUserLevel = getUserLevel
Vue.prototype.$getChangeLink = getChangeLink
Vue.prototype.$getBase64img = getBase64img
Vue.prototype.$getSelectSkuList = getSelectSkuList
Vue.prototype.$getCategoryList = getCategoryList
Vue.prototype.$getEventsApi = getEventsApi
Vue.prototype.$getPidLevelCountList = getPidLevelCountList
Vue.prototype.$getPhoneRegist = getPhoneRegist
Vue.prototype.$modifyPassword = modifyPassword
Vue.prototype.$getPhoneVerifyCode = getPhoneVerifyCode
Vue.prototype.$checkPhoneVerifyCode = checkPhoneVerifyCode
Vue.prototype.$getWxQRUrl = getWxQRUrl
Vue.prototype.$syncUserOpenid = syncUserOpenid
Vue.prototype.$getWxAppQrcode = getWxAppQrcode
Vue.prototype.$getWxUserinfo = getWxUserinfo
Vue.prototype.$getGloabl_WxUserinfo = getGloabl_WxUserinfo
Vue.prototype.$saveUserinfoToServer = saveUserinfoToServer
Vue.prototype.$wx = wx
Vue.prototype.$getUpdatePhone = getUpdatePhone
Vue.prototype.$getOrderBySumbit = getOrderBySumbit
Vue.prototype.$getOrderByFinishXls = getOrderByFinishXls
Vue.prototype.$getXls = getXls
Vue.prototype.$resetPassword = resetPassword
Vue.prototype.$postImage = postImage
Vue.prototype.$sendMessageToWechat = sendMessageToWechat
Vue.prototype.$sendMessageToWechat_ByTs = sendMessageToWechat_ByTs
Vue.prototype.$submitToExamine = submitToExamine
Vue.prototype.$checkExamine = checkExamine
Vue.prototype.$getQrUrl = getQrUrl
Vue.prototype.$getFansList = getFansList
Vue.prototype.$getAccountListByPhone = getAccountListByPhone
Vue.prototype.$auto_login = auto_login
Vue.prototype.$getShareDatas = getShareDatas
Vue.prototype.$getNewChannelName = getNewChannelName
Vue.prototype.$getIncometByData = getIncometByData
Vue.prototype.$getLevelCountTotal = getLevelCountTotal
Vue.prototype.$getEverydayCountList = getEverydayCountList
Vue.prototype.$getEverydayUserCountList = getEverydayUserCountList
Vue.prototype.$getLevelCountData = getLevelCountData
Vue.prototype.$sendMessageToPublic = sendMessageToPublic
Vue.prototype.$getGroupActiveValue = getGroupActiveValue
Vue.prototype.$getPopDatas = getPopDatas
Vue.prototype.$getDatasWithUrlAndParams = getDatasWithUrlAndParams
Vue.prototype.$getDatasWithUrlAndParams_Post = getDatasWithUrlAndParams_Post
Vue.prototype.$clickHomeModelTo = clickHomeModelTo
Vue.prototype.$getActionInfo = getActionInfo
Vue.prototype.$getActionList = getActionList
Vue.prototype.$getPid = getPid
Vue.prototype.$getReturnCashData = getReturnCashData
Vue.prototype.$getRobotByChannelname = getRobotByChannelname
Vue.prototype.$getRobotList = getRobotList
Vue.prototype.$postContentToRobot = postContentToRobot
Vue.prototype.$getPostToRobotData = getPostToRobotData
Vue.prototype.$getDataListFromRobot = getDataListFromRobot
Vue.prototype.$getDataListFromRobot_noPush = getDataListFromRobot_noPush
Vue.prototype.$getDataListFromRobot_Pushed = getDataListFromRobot_Pushed
Vue.prototype.$getDataListFromRobot_All = getDataListFromRobot_All
Vue.prototype.$getAllDataListFromRobot_withLimitTime = getAllDataListFromRobot_withLimitTime
Vue.prototype.$deleteDataFromRobot = deleteDataFromRobot
Vue.prototype.$sendRobotStatus = sendRobotStatus
Vue.prototype.$sendRobotSkuList_Sorted = sendRobotSkuList_Sorted
Vue.prototype.$getUserInfo = getUserInfo
Vue.prototype.$postWxUserData = postWxUserData
Vue.prototype.$getUserActiveStatus = getUserActiveStatus
Vue.prototype.$submitToGetAward = submitToGetAward
Vue.prototype.$getUserPayToAll = getUserPayToAll
Vue.prototype.$getWxPublicSignature = getWxPublicSignature
Vue.prototype.$saveShortUrl = saveShortUrl

//--------------------以下--淘宝--------------------------
import common_tb from './js_tb/common_tb'
import {
  getSelectGoods_tb,
  getSelectGoodsJson_tb,
  getSkuDetailData_tb,
  getTbCommand_tb,
  getOrderList_tb,
  getOrderByFinish_tb,
  getIncometByData_tb,
  getEverydayCountList_tb,
  getPidLevelCountList_tb,
  getLevelCountData_tb,
  getUserPayTo_tb,
  getUserPayList_tb,
  getOrderBySumbit_tb,
  getOrderByFinishXls_tb,
  getUserSubmit_tb,
  getSubConfig_tb,
  getSelectGoods_AllParams_tb,
  getElemeData,
} from './js_tb/utils_tb'

Vue.prototype.$common_tb = common_tb
Vue.prototype.$getSelectGoods_tb = getSelectGoods_tb
Vue.prototype.$getSelectGoodsJson_tb = getSelectGoodsJson_tb
Vue.prototype.$getSkuDetailData_tb = getSkuDetailData_tb
Vue.prototype.$getTbCommand_tb = getTbCommand_tb
Vue.prototype.$getOrderList_tb = getOrderList_tb
Vue.prototype.$getOrderByFinish_tb = getOrderByFinish_tb
Vue.prototype.$getIncometByData_tb = getIncometByData_tb
Vue.prototype.$getEverydayCountList_tb = getEverydayCountList_tb
Vue.prototype.$getPidLevelCountList_tb = getPidLevelCountList_tb
Vue.prototype.$getLevelCountData_tb = getLevelCountData_tb
Vue.prototype.$getUserPayTo_tb = getUserPayTo_tb
Vue.prototype.$getUserPayList_tb = getUserPayList_tb
Vue.prototype.$getOrderBySumbit_tb = getOrderBySumbit_tb
Vue.prototype.$getOrderByFinishXls_tb = getOrderByFinishXls_tb
Vue.prototype.$getUserSubmit_tb = getUserSubmit_tb
Vue.prototype.$getSubConfig_tb = getSubConfig_tb
Vue.prototype.$getSelectGoods_AllParams_tb = getSelectGoods_AllParams_tb
Vue.prototype.$getElemeData = getElemeData

//--------------------以上--淘宝--------------------------

//--------------------以下--拼多多--------------------------
import common_pdd from './js_pdd/common_pdd'
import {
  getSelectGoods_pdd,
  getTopGoods_pdd,
  getGoodsCats_pdd,
  getSkuDetailData_pdd,
  getExtendLink_pdd,
  getOrderList_pdd,
  getOrderByFinish_pdd,
  getIncometByData_pdd,
  getEverydayCountList_pdd,
  getPidLevelCountList_pdd,
  getLevelCountData_pdd,
  getUserPayTo_pdd,
  getUserPayList_pdd,
  getOrderBySumbit_pdd,
  getOrderByFinishXls_pdd,
  getUserSubmit_pdd,
  getSubConfig_pdd,
  getExtendLinkParams_pdd,
  getPinduoduoPid_pdd,
  checkAuthRecord_pdd,
  getBindAuthRecordData_pdd,
} from './js_pdd/utils_pdd'

Vue.prototype.$common_pdd = common_pdd
Vue.prototype.$getSelectGoods_pdd = getSelectGoods_pdd
Vue.prototype.$getTopGoods_pdd = getTopGoods_pdd
Vue.prototype.$getGoodsCats_pdd = getGoodsCats_pdd
Vue.prototype.$getSkuDetailData_pdd = getSkuDetailData_pdd
Vue.prototype.$getExtendLink_pdd = getExtendLink_pdd
Vue.prototype.$getOrderList_pdd = getOrderList_pdd
Vue.prototype.$getOrderByFinish_pdd = getOrderByFinish_pdd
Vue.prototype.$getIncometByData_pdd = getIncometByData_pdd
Vue.prototype.$getEverydayCountList_pdd = getEverydayCountList_pdd
Vue.prototype.$getPidLevelCountList_pdd = getPidLevelCountList_pdd
Vue.prototype.$getLevelCountData_pdd = getLevelCountData_pdd
Vue.prototype.$getUserPayTo_pdd = getUserPayTo_pdd
Vue.prototype.$getUserPayList_pdd = getUserPayList_pdd
Vue.prototype.$getOrderBySumbit_pdd = getOrderBySumbit_pdd
Vue.prototype.$getOrderByFinishXls_pdd = getOrderByFinishXls_pdd
Vue.prototype.$getUserSubmit_pdd = getUserSubmit_pdd
Vue.prototype.$getSubConfig_pdd = getSubConfig_pdd
Vue.prototype.$getExtendLinkParams_pdd = getExtendLinkParams_pdd
Vue.prototype.$getPinduoduoPid_pdd = getPinduoduoPid_pdd
Vue.prototype.$checkAuthRecord_pdd = checkAuthRecord_pdd
Vue.prototype.$getBindAuthRecordData_pdd = getBindAuthRecordData_pdd

//--------------------以上--拼多多--------------------------

// --------------------以下--美团--------------------------
import common_mt from './js_meituan/common_mt'
import {
  getMeituanPid,
  getUserPayTo_mt,
  getUserPayList_mt,
  getPidLevelCountList_mt,
  getEverydayCountList_mt,
  getLevelCountData_mt,
  getOrderByFinish_mt,
  getOrderByFinishXls_mt,
  getOrderBySumbit_mt,
  getIncometByData_mt,
  getSubConfig_mt,
  getOrderList_mt,
} from './js_meituan/utils_mt'

Vue.prototype.$common_mt = common_mt
Vue.prototype.$getMeituanPid = getMeituanPid
Vue.prototype.$getUserPayTo_mt = getUserPayTo_mt
Vue.prototype.$getUserPayList_mt = getUserPayList_mt
Vue.prototype.$getPidLevelCountList_mt = getPidLevelCountList_mt
Vue.prototype.$getEverydayCountList_mt = getEverydayCountList_mt
Vue.prototype.$getLevelCountData_mt = getLevelCountData_mt
Vue.prototype.$getOrderByFinish_mt = getOrderByFinish_mt
Vue.prototype.$getOrderByFinishXls_mt = getOrderByFinishXls_mt
Vue.prototype.$getOrderBySumbit_mt = getOrderBySumbit_mt
Vue.prototype.$getIncometByData_mt = getIncometByData_mt
Vue.prototype.$getSubConfig_mt = getSubConfig_mt
Vue.prototype.$getOrderList_mt = getOrderList_mt

// --------------------以上--美团--------------------------

// Vue.prototype.$QRCode=QRCode;
// Vue.prototype.$html2canvas=html2canvas;

Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false

// let that=this;
// router.beforeEach((to, from, next) => {
//     let isLogin = store.getters.isLogin;
//     if (!isLogin) {
//         if (to.path !== '/login') {
//
//             return next({path: '/login'})
//         } else {
//             next();
//         }
//     } else {
//         //已登录
//         next();
//     }
// });

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
